<template>
  <fragment>
    <div class="body-wrapper-inner">
      <div class="container-fluid">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title fw-semibold mb-4">{{formTitle}} Artikel</h5>
            <hr class="border-0 pt-1 rounded bg-primary my-4">

            <!-- <ul class="nav gap-1 mb-4">
              <li class="nav-item">
                <a class="btn btn-sm btn-success py-2 px-3 lh-1" href="form-post.php">Artikel</a>
              </li>
              <li class="nav-item">
                <a
                  class="btn btn-sm btn-outline-success py-2 px-3 lh-1"
                  href="form-post_video.php"
                >Video</a>
              </li>
            </ul>-->

            <form @submit.prevent="onSubmit">
              <div class="row g-4">
                <div class="col-md-7 col-lg-8 col-xl-9">
                  <div class="mb-4">
                    <label for class="form-label">Judul Artikel *</label>
                    <input
                      v-model="form.title"
                      type="text"
                      class="form-control form-control-lg rounded"
                      placeholder="Judul Artikel..."
                      autocomplete="off"
                      required
                    >
                  </div>
                  <div class="mb-4">
                    <label for class="form-label">Embed Video URL</label>
                    <input
                      v-model="form.embed_url"
                      type="url"
                      class="form-control form-control-lg rounded"
                      placeholder="https://..."
                      autocomplete="off"
                    >
                    <!-- Pesan error -->
                    <p
                      v-if="form.embed_url && !youtubeId"
                      style="color: red;"
                    >URL tidak valid, pastikan link YouTube benar</p>
                  </div>
                  <div class="mb-4">
                    <label for class="form-label">Isi Artikel *</label>
                    <quill-editor
                      v-model="form.content"
                      :options="editorOption"
                      style="min-height: 200px"
                    />
                  </div>
                  <div v-if="youtubeId">
                    <label for class="form-label">Pratinjau</label>
                    <div class="video-container text-center border border-5">
                      <iframe
                        :src="`https://www.youtube.com/embed/${youtubeId}`"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin"
                        allowfullscreen
                      ></iframe>
                    </div>
                  </div>
                </div>

                <div class="col-sm-6 col-md-5 col-lg-4 col-xl-3">
                  <div class="bg-light p-4 rounded">
                    <div class="d-none d-md-block">
                      <button type="submit" class="btn btn-primary w-100 liveToastBtn">Simpan</button>
                      <hr class="border-0 pt-1 bg-dark rounded my-4">
                    </div>

                    <div class="mb-4">
                      <div class="rounded-4shadow-sm mb-3">
                        <img
                          v-if="previewNotSave != ''"
                          :src="previewNotSave"
                          alt="preview"
                          class="img-fluid rounded-3 not-save"
                        >
                        <img
                          v-else-if="preview == ''"
                          src="../assets/images/products/s1.jpg"
                          class="img-fluid rounded-3"
                          alt="no-img"
                        >
                        <img v-else :src="preview" alt="preview" class="img-fluid rounded-3">
                      </div>
                      <button
                        @click="triggerFileInput"
                        type="button"
                        class="btn btn-sm btn-outline-success w-100 rounded"
                      >Upload Image</button>
                      <input
                        type="file"
                        @change="onFileChange"
                        ref="fileInput"
                        style="display: none"
                      >
                    </div>

                    <hr>

                    <label for class="form-label">Segmentasi Usia Kehamilan</label>
                    <div class="ps-3 py-3 pe-1 rounded bg-white mb-4">
                      <div style="overflow-y: auto;max-height: 200px;">
                        <div v-for="n in 3" :key="`t${n}`" class="form-check mb-2">
                          <input
                            v-model="selectedTrimester"
                            :value="`${n}`"
                            name="type_exa[]"
                            type="checkbox"
                            class="form-check-input"
                            :id="`xampleCheck00_${n}`"
                            autocomplete="off"
                          >
                          <label class="form-check-label" :or="`xampleCheck00_${n}`"> Trimester {{n}}</label>
                        </div>

                        <!-- <div v-for="n in 41" :key="n" class="form-check mb-2">
                          <input
                            v-model="form.target_visitor"
                            :value="n"
                            name="type_examination[]"
                            type="checkbox"
                            class="form-check-input"
                            :id="`exampleCheck00_${n}`"
                            autocomplete="off"
                          >
                          <label class="form-check-label" :or="`exampleCheck00_${n}`">{{n}} Minggu</label>
                        </div> -->
                      </div>
                    </div>

                    <label for class="form-label">Status</label>
                    <div class="mb-4">
                      <div class="form-check form-check-inline">
                        <input
                          v-model="form.statusId"
                          class="form-check-input"
                          type="radio"
                          name="inlineRadioOptions"
                          id="inlineRadio1"
                          value="7"
                          autocomplete="off"
                        >
                        <label class="form-check-label" for="inlineRadio1">Publish</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input
                          v-model="form.statusId"
                          class="form-check-input"
                          type="radio"
                          name="inlineRadioOptions"
                          id="inlineRadio2"
                          value="8"
                          autocomplete="off"
                        >
                        <label class="form-check-label" for="inlineRadio2">Draft</label>
                      </div>
                    </div>

                    <div class="d-md-none">
                      <hr class="border-0 pt-1 bg-dark rounded my-4">
                      <button type="submit" class="btn btn-primary w-100 liveToastBtn">Simpan</button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
import { mapGetters } from 'vuex'
import Highlight from '../components/Highlight.vue'
import EmptyPlaceholder from '../components/EmptyPlaceholder.vue'
import config from '../config'

export default {
	components: {
		Highlight,
		EmptyPlaceholder
	},
	data() {
		return {
			user_login: JSON.parse(localStorage.getItem('user_login')).data,
			token: localStorage.getItem('token'),
			form: {
				title: '',
				content: '',
				attachment: '',
				embed_url: '',
				redirect_url: '',
				target_visitor: [],
				type: 'article',
				statusId: 7
			},
			selectedTrimester: [],
			editorOption: {
				theme: 'snow'
			},
			previewNotSave: '',
			file: '',
			formTitle: 'Tambah',
			url: 'posts/',
			// url: 'posts/' + this.user_login.id,
			method: 'post'
		}
	},
	created() {
		if (!this.token) {
			this.$router.push('/login')
		}
		// this.getDataList()
		// this.$store.commit("settings/setMenuActive", "dc-location");
		// this.$store.dispatch("auth/getNotif");
		if (this.id) {
			this.formTitle = 'Ubah'
			this.$store
				.dispatch('location/getDataPayload', {
					url: `posts/${this.id}`
				})
				.then((res) => {
					let data = res.payload
					this.form = {
						title: data.title,
						content: data.content,
						attachment: data.attachment,
						embed_url: data.embed_url,
						redirect_url: data.redirect_url,
						target_visitor: data.target_visitor.split(',').map(Number),
						type: data.type,
						statusId: data.statusId
					}
				})
		}
	},
	computed: {
		...mapGetters({
			// dataList: 'location/getDCLocation',
			// countDataList: 'location/getCountDCLocation',
			dataPost: 'location/getDataPayload'
		}),
		minggu() {
			const trimesterWeeks = {
				1: Array.from({ length: 12 }, (_, i) => i + 1), // 1–12
				2: Array.from({ length: 15 }, (_, i) => i + 13), // 13–27
				3: Array.from({ length: 14 }, (_, i) => i + 28) // 28–41
			}

			const weeks = this.selectedTrimester.flatMap((t) => trimesterWeeks[t]).sort((a, b) => a - b)

			return weeks.join(',')
		},
		preview: {
			// getter
			get() {
				let url = ''
				if (this.form.attachment == null || this.form.attachment == '' || this.form.attachment == 'undefined') {
				} else {
					url = config('api.baseUrl') + 'storage/uploads/' + this.form.attachment
				}
				return url
			},
			set(value) {
				this.form.attachment = value
			}
		},
		id: {
			// getter
			get() {
				return this.$route.query.id || ''
			}
		},
		youtubeIdTanpaShortYT() {
			if (!this.form.embed_url) return null

			// regex ambil video ID dari URL YouTube
			const regExp = /^.*(?:youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/
			const match = this.form.embed_url.match(regExp)

			// valid ID YouTube panjangnya 11 karakter
			return match && match[1].length === 11 ? match[1] : null
		},
		youtubeId() {
			if (!this.form.embed_url) return null

			const patterns = [/youtu\.be\/([^?&]+)/, /youtube\.com\/watch\?v=([^?&]+)/, /youtube\.com\/embed\/([^?&]+)/, /youtube\.com\/shorts\/([^?&]+)/]

			for (const pattern of patterns) {
				const match = this.form.embed_url.match(pattern)
				if (match && match[1]) {
					return match[1]
				}
			}

			return null
		}
	},
	methods: {
		triggerFileInput() {
			this.$refs.fileInput.click() // klik input file tersembunyi
		},
		onFileChange(e) {
			const file = e.target.files[0]
			if (file) {
				this.file = file
				this.previewNotSave = URL.createObjectURL(file) // buat preview gambar
			}
		},
		onSubmit() {
			if (this.file) {
				let formData = new FormData()
				formData.append('image', this.file)
				this.$store.dispatch('location/upload', formData).then((res) => {
					console.log('res dari api set img==>', res)
					this.preview = res.filename
					this.storeData(res.filename)
				})
			} else {
				this.storeData('')
			}
		},
		storeData(attachment) {
			let endpoint = this.url + this.user_login.id
			if (attachment) {
				this.form.attachment = attachment
			}
			// jika edit
			if (this.id != '') {
				endpoint = this.url + this.id
				this.method = 'PUT'
			}

			this.form.target_visitor = this.minggu
			// console.log('-->',this.form.target_visitor)
			// return
			// this.form.target_visitor = this.form.target_visitor.join(',')
			this.$store
				.dispatch('location/createNewRecord', {
					data: this.form,
					url: endpoint,
					method: this.method
				})
				.then((res) => {
					console.log(res)
					let toast = this.$toasted.show(`${res.msg}`, {
						theme: 'bubble',
						position: 'top-right',
						duration: 3000
					})
					if (res.statusCode == 200) {
						this.method = 'POST'
						this.form = {
							id: '',
							title: '',
							content: '',
							attachment: '',
							embed_url: '',
							redirect_url: '',
							target_visitor: '',
							type: 'article',
							statusId: 7
						}
						this.$router.push('/post')
					} else {
					}
				})
		},
		deleteData(id) {
			var conf = confirm('Kamu akan menghapus rekaman ini. Apa kamu yakin?')
			if (conf === false) {
				return
			}

			this.$store
				.dispatch('location/createNewRecord', {
					url: 'posts/' + id,
					method: 'DELETE'
				})
				.then((res) => {
					console.log(res)
					let toast = this.$toasted.show(`${res.msg}`, {
						theme: 'bubble',
						position: 'top-right',
						duration: 3000
					})
					if (res.statusCode == 200) {
						this.getDataList()
					} else {
					}
				})
		},
		edit(id) {
			let data = this.dataList.find((o) => o.id === id)
			console.log(data)
			this.form = {
				id: id,
				location_name: data.location_name,
				address: data.address,
				city: data.city,
				province: data.province,
				postal_code: data.postal_code,
				country: data.country,
				email: data.email,
				phone_number: data.phone_number,
				map_url: data.map_url,
				statusId: data.statusId
			}
			this.formTitle = 'Edit'
			this.url = 'location/' + id
			this.method = 'put'
		}
	}
}
</script>

<style lang="scss">
.file {
	position: relative;
	overflow: hidden;
}

.input-file {
	position: absolute;
	font-size: 50px;
	opacity: 0;
	right: 0;
	top: 0;
}

.ql-editor {
	min-height: 500px;
	overflow-y: auto; /* Adds a vertical scrollbar if content overflows */
}
</style>

